<template>
    <div class="overlay" @click.stop="closeOverlay">
        <div class="overlay_inner channel_list" @click.stop>

            <div class="epg_plus_process_summary" v-if="isLoaded">
                <p>{{ translations.totalProcessed }} <span>{{ Math.round((data.totals.processed_count / data.totals.total_broadcasts) * 100) }} %</span></p>
                <p>{{ translations.totalUnprocessed }} <span>{{ data.totals.total_broadcasts - data.totals.processed_count }} / {{ data.totals.total_broadcasts }} </span></p>
            </div>

            <p class="note">{{ translations.title }}</p>

            <div class="selected_stations epg_plus_process">
                <table class="vypis" v-if="isLoaded">
                    <thead>
                        <tr>
                            <th>{{ translations.station }}</th>
                            <th>{{ translations.status }}</th>
                            <th>{{ translations.unprocessed }}</th>
                            <th>{{ translations.total }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="channel in data.channels">
                            <td><strong>{{ channel.name }}</strong></td>
                            <td>{{ Math.round((channel.processed_count / channel.total_broadcasts) * 100) }} %</td>
                            <td>{{ channel.total_broadcasts - channel.processed_count }}</td>
                            <td>{{ channel.total_broadcasts }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <a class="btn btn_action btn_close" title="Zavřít" @click.stop="closeOverlay">Zavřít</a>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { VUE_APP_BASE_API_URL, VUE_APP_BASE_AUTH_URL } from '@/constants/fileConstants'

export default {
  name: 'StatisticOverlay',
  created() {
    this._obtainStatistics()
  },
  data() {
    return {
      data: {},
      isLoaded: false
    }
  },
  computed: {
    translations() {
      return {
        title: this.$gettext('Stav zpracování EPG+'),
        station: this.$gettext('Kanál'),
        status: this.$gettext('Stav zpracování'),
        unprocessed: this.$gettext('Nezpracováno'),
        total: this.$gettext('Celkem'),
        totalProcessed: this.$gettext('Celkem zpracováno'),
        totalUnprocessed: this.$gettext('Celkem nezpracováno'),
        close: this.$gettext('Zavřít')
      }
    }
  },
  methods: {
    _obtainStatistics() {
      const endPoint = VUE_APP_BASE_API_URL + 'broadcasts/getStatus/'

      axios.get(endPoint).then((statistics) => {
        this.data = statistics.data

        this.isLoaded = true
      })
    },
    closeOverlay() {
      this.$emit('close')
    }
  }
}
</script>
